<template>
  <hb-basic-page
      :action-buttons="$vuetify.breakpoint.smAndDown ? {create: titleButton} : {}"
      :fill-height="loading || messages.length === 0"
      :loading="loading"
      :subtle-loading="subtleLoading"
      :title="$t(`message_center.title`)"
      :title-button="titleButton"
      name="message-center-view"
      @handle-search="handleSearch"
  >
    <v-col v-if="!loading && messages.length > 0" cols="12" offset-xl="1"
           xl="10">
      <v-data-table
          :footer-props="{ itemsPerPageOptions: [50, 100, 500, -1] }"
          :headers="headers"
          :items="filteredMessages"
          :items-per-page="50"
          :loading="loading"
          :options.sync="options"
          style="cursor: pointer"
          @click:row="openEditMessageView"
      >
        <template v-slot:item.published="{item}">
          <v-icon v-if="!item.published">mdi mdi-checkbox-blank-outline</v-icon>
          <v-icon v-else>mdi mdi-checkbox-marked-outline</v-icon>
        </template>
        <template v-slot:item.sticky="{item}">
          <v-icon v-if="item.sticky">mdi mdi-checkbox-marked-outline</v-icon>
        </template>
        <template v-slot:item.createdAt="{item}">
          {{ $formatDateTime(item.createdAt) }}
        </template>
        <template v-slot:item.category="{item}">
          <span>{{ getCategoryText(item) }}</span>
        </template>
        <template v-slot:item.actions="{item}">
          <v-btn color="error" icon @click.stop.prevent="deleteMessage(item)">
            <v-progress-circular v-if="item._deleteLoading" :size="18" :width="3" color="primary"
                                 indeterminate></v-progress-circular>
            <v-icon v-else>mdi mdi-delete</v-icon>

          </v-btn>
        </template>

      </v-data-table>
    </v-col>

    <v-col v-if="!loading && messages.length === 0" class="pa-0 fill-height" cols="12" lg="10" md="10" offset-lg="1"
           offset-md="1" offset-xl="2"
           xl="8">
      <v-row align="center" class="fill-height" no-gutters>
        <no-content-view
            :function-button="true"
            :function-button-text="$t('message_center.create_message')"
            :prop-function="handleCreateMessage"
            :reload-button="true"
            :title="$t('message_center.no_messages')"
            function-button-icon="add"
            title-icon="mdi mdi-playlist-edit"/>
      </v-row>
    </v-col>

  </hb-basic-page>
</template>

<script>
import NoContentView from "@/components/NoContentView";
import debounce from "lodash.debounce";
import messagecenterApi from '@/api/messagecenter';
import LoadingIndicator from "@/components/LoadingIndicator.vue";

export default {
  name: "AdminMessageCenterView",
  components: {LoadingIndicator, NoContentView},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      options: {},
      messages: [],
      titleButton: {
        text: this.$t('message_center.create_message'),
        icon: 'add',
        callback: this.handleCreateMessage,
        primary: true,
      },
      headers: [
        {
          text: this.$t('message_center.title_field'),
          value: 'title',
        },
        {
          text: this.$tc('message_center.message', 2),
          value: 'message',
        },
        {
          text: this.$t('message_center.category'),
          value: 'category',
        },
        {
          text: this.$t('message_center.author'),
          value: 'author',
          width: '150px',
        },
        {
          text: this.$t('message_center.published'),
          value: 'published',
          width: '150px',
        },
        {
          text: this.$t('message_center.sticky'),
          value: 'sticky',
          width: '150px',
        },
        {
          text: this.$t('message_center.created_at'),
          value: 'createdAt',
//          width: '150px',
        },
        {
          value: 'actions',
          width: '60px',
          sortable: false,
        },
      ],
      searchString: '',
    }
  },
  methods: {
    getCategoryText(item) {
      return this.categories.find(c => c.value === item.category).text
    },
    handleCreateMessage() {
      this.$router.push({name: 'create_messagecenter_message'});
    },
    openEditMessageView(task) {
      this.$router.push({name: "edit_messagecenter_message", params: {id: task.id}});
    },
    async reloadMessages() {
      if (this.messages.length > 0) {
        this.subtleLoading = true;
        this.loading = false;
      } else {
        this.subtleLoading = false;
        this.loading = true;
      }
      try {
        let messages = await messagecenterApi.getMessagesAdmin();
        this.messages = messages?.map(m => {
          m._deleteLoading = false;
          return m;
        });
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_loading_messages'));
      }
      this.loading = false;
      this.subtleLoading = false;
    },
    handleSearch(e) {
      this.searchString = e;
    },
    async deleteMessage(message) {
      const confirm = await this.$confirmDelete(this.$t('message_center.confirm_delete'), this.$t('message_center.confirm_delete_text'));
      if (!confirm) return;

      message._deleteLoading = true;
      try {
        await messagecenterApi.deleteMessage(message.id);
        this.$showSuccessNotification(this.$t('message_center.deleted_successfully'));
        message._deleteLoading = false;
        this.reloadMessages();
      } catch (error) {
        this.$handleApiError(error, this.$t('errors.error_deleting_message'));
      }
    },
  },
  computed: {
    categories() {
      return messagecenterApi.getCategories();
    },
    filteredMessages() {
      return this.messages.map(f => {
        return {
          ...f,
          message: f.message.length > 100 ? f.message.substring(0, 100) + '...' : f.message,
        }
      });
    },
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 450, {maxWait: 5000});
  },
  async mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    await this.reloadMessages();
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
